import React from 'react';
import PropTypes from 'prop-types';

const PlanTechnic = ({ className }) => (
  // <svg
  //   className={className}
  //   width="2515"
  //   height="1350"
  //   xmlns="http://www.w3.org/2000/svg"
  //   viewBox="0 0 2515 1350"
  //   role="presentation"
  // >
  //   <g fillRule="evenodd">
  //     <path d="M128 1044.194l453.273 304.641 1129.03 1.165H2515L892.995 48z" />
  //     <path
  //       stroke="#394750"
  //       strokeWidth="4"
  //       fill="currentColor"
  //       d="M3 999.194l453.273 304.641 1129.03 1.165H2390L767.995 3z"
  //     />
  //     <g className="areas">
  //       <path
  //         fill="#D1D3D4"
  //         d="M615.603 324.591L682.566 289l188.062 390.06-25.643 15.658zM784.457 612.018L732.41 648.18 874.7 821.2l30.97-20.562zM602.95 429.207l45.848-34.156 122.546 195.69-36.698 24.196zM1092.682 358.08l50.493 9.338-46.167 248.491-34.624-4.312zM1018.328 441.752l55.737 3.708-22.093 187.962-40.203-2.633z"
  //       />
  //       <path
  //         fill="#D1D3D4"
  //         d="M1103.8 613.964l39.375 7.32-53.755 220.349-46.503-8.559 24.348-212.504 34.67 3.95zM994.142 667.476l55.588 2.142-27.796 247.904-30.606-3.568zM1030.263 954.363l28.32 4.996 25.216-112.078-41.063-8.567zM1545.551 792.985l70.686 84.427-178.5 123.784-49.27-60.817zM1658 858.173l-335.723 236.046 16.425 25.676 359.3-197.54zM1406.866 972.98l27.35 33.63-177.81 123.987-14.92-20.122z"
  //       />
  //       <path fill="#D1D3D4" d="M1590.93 1167.048l4.858 56.952L1954 1204.534l-12.133-100.206z" />
  //       <path
  //         fill="#D1D3D4"
  //         d="M553.307 819.411l29.761-45.884 206.77 144.99-14.956 24.302zM368.365 825.117l36.45-77.86 213.708 118.577-25.013 50.715zM448.508 618.828l147.627 117.52-50.338 77.07-165.752-91.366zM307.54 949.027l-26.084 81.84 179.271 50.054 23.645-72.17zM490.9 1026.674l-18.11 59.337 352.943 99.173 10.628-28.501zM666.711 889.307l-16.066 32.266 146.936 66.974 10.751-21.803zM1283.438 447.59l-42.925 126.603 230.362 79.661 31.477-37.693z"
  //       />
  //     </g>
  //   </g>
  // </svg>

  <svg
    width="2515"
    height="1350"
    viewBox="0 0 2515 1350"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    role="presentation"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M128 1044.19L581.273 1348.83L1710.3 1350H2515L892.995 48L128 1044.19Z"
      fill="#B61F52"
    />
    <path
      d="M1582.3 1299.5L454.036 1298.34L3.60472 995.605L765.422 3.54857L2379.89 1299.5H1582.31H1582.3Z"
      fill="currentColor"
      stroke="#B61F52"
      strokeWidth="5"
    />
    <g className="areas">
      <path
        d="M1229.93 400.338L1174.88 390.328L1144.85 670.605H1179.88L1229.93 400.338Z"
        fill="#B61F52"
      />
      <path
        d="M797.177 425.047H781.742L743.154 201.239L943.811 185.804V409.612H928.376L918.478 212.681L774.025 224.392L797.177 425.047Z"
        fill="#B61F52"
      />
      <path
        d="M682.219 422.9L610.576 460.051L849.096 875.516L874.712 861.534L682.219 422.9Z"
        fill="#B61F52"
      />
      <path
        d="M647.319 541.693L600.884 574.863L737.545 785.81L778.571 762.438L647.319 541.693Z"
        fill="#B61F52"
      />
      <path
        d="M789.779 785.458L733.343 818.22L885.618 1014.78L916.439 995.997L789.779 785.458Z"
        fill="#B61F52"
      />
      <path
        d="M1135.86 690.625H1090.82L1095.82 480.417L1157.64 485.345L1135.86 690.625Z"
        fill="#B61F52"
      />
      <path
        d="M1144.85 675.618L1119.82 900.84L1169.87 910.85L1229.93 670.613L1186.86 660.039L1183.54 675.618H1144.85Z"
        fill="#B61F52"
      />
      <path
        d="M1132.33 730.662H1072.27L1067.27 1000.93L1102.3 1005.93L1132.33 730.662Z"
        fill="#B61F52"
      />
      <path
        d="M1119.74 907.363L1104.8 1030.96L1134.83 1035.96L1159.86 915.844L1119.74 907.363Z"
        fill="#B61F52"
      />
      <path
        d="M1351.34 470.672L1302.33 615.551L1552.57 705.639L1587.94 660.568L1351.34 470.672Z"
        fill="#B61F52"
      />
      <path
        d="M1490.19 995.929L1435.13 930.865L1605.3 765.702L1685.38 855.791L1490.19 995.929Z"
        fill="#B61F52"
      />
      <path
        d="M1294.99 1136.06L1274.97 1111.04L1450.15 960.892L1485.18 1000.93L1294.99 1136.06Z"
        fill="#B61F52"
      />
      <path
        d="M1391.06 1113.23L1376.05 1088.21L1741.41 822.947L1786.46 893.016L1391.06 1113.23Z"
        fill="#B61F52"
      />
      <path
        d="M1658.81 1160.15L1663.81 1225.21L2059.21 1205.19L2044.19 1095.08L1658.81 1160.15Z"
        fill="#B61F52"
      />
      <path
        d="M505.559 893.185L324.608 785.622L404.312 673.664L564.035 810.415L505.559 893.185Z"
        fill="#B61F52"
      />
      <path
        d="M583.532 946.46L556.285 1000.45L315.324 890.439L358.594 812.058L583.532 946.46Z"
        fill="#B61F52"
      />
      <path
        d="M544.121 849.258L511.293 897.529L741.028 1037.14L762.051 1012.95L544.121 849.258Z"
        fill="#B61F52"
      />
      <path
        d="M632.316 978.503L616.09 1007.9L773.057 1089.43L783.874 1069.84L632.316 978.503Z"
        fill="#B61F52"
      />
      <path
        d="M185.441 1019.62L175.361 1088.34L320.22 1105.17L329.856 1047.34L185.441 1019.62Z"
        fill="#B61F52"
      />
      <path
        d="M335.301 1068.57L322.444 1138.17L724.603 1190.53L732.511 1154.9L335.301 1068.57Z"
        fill="#B61F52"
      />
    </g>
  </svg>
);

PlanTechnic.propTypes = {
  className: PropTypes.string
};

export default PlanTechnic;
